<form class="custom-forms form-horizontal" action="#" method="POST" novalidate="novalidate" id="form_body" [formGroup]="pmsFiltter">
    <div class="row generalSearchSection" >
        <div class="col-lg-12 row">
            <div class="col-lg-6 d-flex reportFilter">
                <!-- customer Name  multiselect -->
                <div class="col-lg-6 d-flex pull-left mr-2">
                    <select formControlName="customer_name"  class="form-control" disabled>
                        <option value="1" hidden>{{cusCode}}-{{cusName}}</option>
                    </select>
                </div>
                <!-- Facility Department multiselect -->
                <div class="col-lg-6 d-flex pull-left mr-2">
                    <ng-multiselect-dropdown style="width: 100%;" class="multidrop" (keydown.enter)="$event.preventDefault()" name="Facility Department" 
                    [placeholder]="'Facility Department '" [data]="facility_department" formControlName="FacilityDepart"
                    [settings]="dropdownFacilityDepartSettings" (onSelect)="onItemSelectFacilityDepart($event)"
                    (onSelectAll)="onSelectAllFacilityDepart($event)" (onDeSelect)="onItemDeSelectFacilityDepart($event)"
                    (onDeSelectAll)="onItemDeSelectAllFacilityDepart($event)">
                  </ng-multiselect-dropdown>
                </div>
            </div>
            <div class="col-lg-6 d-flex reportFilter">
                <!-- Facility Department multiselect -->
                <div class="col-lg-6 d-flex pull-left mr-2">
                    <div class="input-group">
                        <select class="form-control" formControlName="selected_period" (change)="onChangePeriod($event.target.value)">
                        <option value='MTD'>MTD</option>
                        <option value='QTD'>QTD</option>
                        <option value='YTD'>YTD</option>
                        <option value=''>Duration</option>
                        </select>
                    </div>&nbsp;&nbsp;&nbsp;
                </div>
                <div class="col-lg-6 d-flex pull-left mr-2">
                    <!-- <label class="control-label" style="margin-right: 35px;">Select Period</label> -->
                        <button class="calenderview w-100" *ngIf="duration_period"> <kt-date [from]="defaultFrom" [to]="defaultTo"
                            (dateRangeSelection)="onDateRangeSelection($event)"></kt-date></button>
                </div>
            </div>
        </div>
    </div>
    <div class="row generalSearchSection" >
        <div class="col-lg-12 row">
            <div class="col-lg-6 d-flex reportFilter">
                <div class="col-lg-6">
                    <!-- <button class="calenderview w-100" *ngIf="duration_period"> <kt-date [from]="defaultFrom" [to]="defaultTo"
                        (dateRangeSelection)="onDateRangeSelection($event)"></kt-date></button> -->
              </div>
            </div>
            <div class="col-lg-2 d-flex mr-2 row justify-content-end"></div>
            <div class="col-lg-4 d-flex mr-2 row justify-content-end">
                <!-- asset status report view button -->
                <button type="button" class="views" (click)="getPmsReport()">{{'RAISETCKT.VIEW'|translate}}<img class="export-img"
                    src="assets/media/icons/png/eye.png"></button>
                <!-- asset status report Export button -->
                <button type="button" class="export ml-2" (click)="exportAsPmsStatusReport()">{{'SITE.EXPORT'|translate}}<img class="export-img"
                    src="assets/media/icons/png/xlsx.png"></button>
                <!-- asset status report reset button -->
                <button type="button" class="btn btnFill ml-2" (click)="reset()">Reset</button>
            </div>
        </div>

    </div>
</form>
<div class="kt-section__content">
    <div class="table-responsive GeneralTable text-nowrap" *ngIf="showTable">
        <table datatable="ng" [dtOptions]="dtOptions" class="table-bordered datatable w-auto mw-100">
            <thead>
                <!-- columns for  table -->
                <tr>
                    <th> # </th>
                    <th> Barcode</th>
                    <th> Ticket ID</th>
                    <th>Facility Nature</th>
                    <th> Facility Name</th>
                    <th> District</th>
                    <th> Product Group</th>
                    <th> Equipment Name</th>
                    <th>Device Model</th>
                    <th>Model</th>
                    <th> Equipment Serial</th>
                    <th>PMS Count</th>
                    <th>PMS Date</th>
                    <th> Assigned BME</th>
                    <th>Current Status</th>
                    <th> Ticket Age</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let items of pmsDataList; let i = index">
                    <td class="datatable-center">{{i+1}}</td>
                    <td>{{items.serial_no}}</td>
                    <td class="linkButton"  (click)="get_ticket_details(items.ticket_id,view_tcktdetails)">{{items.ticket_id}}</td>
                    <td>{{items.facility_nature}}</td>
                    <td>{{items.customer_name}}</td>
                    <td>{{items.city_name}}</td>
                    <td>{{items.product}}</td>
                    <td>{{items.equipment_name}}</td>
                    <td>{{items.model}}</td>
                    <td>{{items.part_number}}</td>
                    <td>{{items.equipment_serial}}</td>
                    <td>{{items.pms_count}}</td>
                    <td>{{items.pms_date}}</td>
                    <td>{{items.technician_name}}</td>
                    <td>{{items.current_status}}</td>
                    <td [ngStyle]="{ color: items?.ticket_age_color }">{{items.ticket_age}}</td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>